// import React from 'react';
// import { Button } from "@/components/ui/button";
// import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
// import { Phone, Mail, Calendar, CheckCircle2, PlayCircle, Activity, Info, ArrowRight } from "lucide-react";

// const  GastricBypass = () => {
//   return (
//     <div className="min-h-screen bg-[#f8fafc] pb-20">
//       {/* Premium Hero Header */}
//       <section className="relative bg-gradient-to-r from-blue-700 to-indigo-800 text-white py-20 px-6 overflow-hidden">
//         <div className="absolute top-0 right-0 w-1/3 h-full bg-white/5 skew-x-12 transform translate-x-20" />
//         <div className="max-w-6xl mx-auto relative z-10">
//           <div className="inline-flex items-center space-x-2 bg-blue-500/30 px-4 py-1.5 rounded-full mb-6 border border-blue-400/30">
//             <Activity className="w-4 h-4 text-blue-200" />
//             <span className="text-sm font-medium text-blue-100">Advanced Bariatric Care</span>
//           </div>
//           <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight mb-6">
//             Laparoscopic <br />
//             <span className="text-blue-300">Sleeve Gastrectomy</span>
//           </h1>
//           <p className="text-xl text-blue-100 max-w-2xl leading-relaxed">
//             Leading the way in minimally invasive weight loss surgery in Meerut. 
//             Transform your life with Dr. Rishi Singhal's expert care.
//           </p>
//         </div>
//       </section>

//       <div className="max-w-7xl mx-auto px-6 -mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8">
        
//         {/* Left Sidebar - Sticky Navigation */}
//         <aside className="lg:col-span-3 space-y-6">
//           <Card className="sticky top-6 shadow-xl border-none bg-white/80 backdrop-blur-md">
//             <CardHeader className="border-b border-gray-100">
//               <CardTitle className="text-lg font-bold text-gray-800 flex items-center gap-2">
//                 <Info className="w-5 h-5 text-blue-600" /> Patient Portal
//               </CardTitle>
//             </CardHeader>
//             <CardContent className="p-4 space-y-2">
//               {['Home', 'About Dr. Rishi', 'Our Services', 'Patient Success'].map((item) => (
//                 <Button key={item} variant="ghost" className="w-full justify-between hover:bg-blue-50 hover:text-blue-700 group transition-all">
//                   {item} <ArrowRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
//                 </Button>
//               ))}
              
//               <div className="mt-8 p-4 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-2xl text-white shadow-lg shadow-blue-200">
//                 <h4 className="font-bold mb-2 flex items-center gap-2">
//                   <Calendar className="w-4 h-4" /> Book Consultation
//                 </h4>
//                 <p className="text-xs text-blue-100 mb-4 leading-relaxed">Schedule your private assessment today.</p>
//                 <Button className="w-full bg-white text-blue-700 hover:bg-blue-50 font-bold shadow-md">
//                   Reserve Now
//                 </Button>
//                 <div className="mt-4 pt-4 border-t border-white/20 space-y-2 text-xs">
//                   <div className="flex items-center gap-2"><Phone className="w-3 h-3" /> +91 95362 29900</div>
//                   <div className="flex items-center gap-2"><Mail className="w-3 h-3" /> help@obesityclinics.com</div>
//                 </div>
//               </div>
//             </CardContent>
//           </Card>
//         </aside>

//         {/* Main Clinical Content */}
//         <main className="lg:col-span-9 space-y-12">
          
//           {/* Procedure Deep Dive */}
//           <section className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100">
//             <div className="flex flex-col md:flex-row gap-12 items-center">
//               <div className="flex-1 space-y-6">
//                 <h2 className="text-3xl font-bold text-gray-900 leading-tight">Understanding the <br/><span className="text-blue-600">Sleeve Procedure</span></h2>
//                 <div className="space-y-4 text-gray-600 text-lg leading-relaxed">
//                   <p>
//                     Laparoscopic sleeve gastrectomy is the gold standard for modern bariatric surgery. 
//                     By removing approximately <span className="font-bold text-gray-900">80% of the stomach</span>, we create a new, 
//                     tube-like pouch.
//                   </p>
//                   <p className="bg-blue-50 border-l-4 border-blue-500 p-4 italic rounded-r-lg">
//                     "Beyond restriction, this surgery removes the portion of the stomach responsible for producing Ghrelin—the primary hunger hormone."
//                   </p>
//                 </div>
//               </div>
//               <div className="flex-1 w-full h-80 bg-gray-100 rounded-2xl overflow-hidden relative shadow-inner">
//                  <img 
//                     src="https://via.placeholder.com/600x400/e2e8f0/475569?text=Procedure+Visual" 
//                     alt="Procedure Details"
//                     className="w-full h-full object-cover"
//                   />
//               </div>
//             </div>
//           </section>

//           {/* Recovery Timeline Redesign */}
//           <section>
//             <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Your Recovery Journey</h3>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-0 rounded-3xl overflow-hidden shadow-lg border border-gray-100">
//               <div className="bg-white p-8 border-b md:border-b-0 md:border-r border-gray-100 text-center">
//                 <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4 font-bold">01</div>
//                 <h4 className="font-bold text-gray-900 mb-2">Weeks 1-2</h4>
//                 <p className="text-sm text-gray-500 uppercase tracking-widest font-semibold mb-3">Clear Liquids</p>
//                 <p className="text-sm text-gray-600">Focus on hydration and allowing the new stomach line to heal.</p>
//               </div>
//               <div className="bg-blue-50/50 p-8 border-b md:border-b-0 md:border-r border-gray-100 text-center">
//                 <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 font-bold">02</div>
//                 <h4 className="font-bold text-gray-900 mb-2">Weeks 3-4</h4>
//                 <p className="text-sm text-blue-600 uppercase tracking-widest font-semibold mb-3">Pureed Food</p>
//                 <p className="text-sm text-gray-600">Introducing soft proteins and blended textures gradually.</p>
//               </div>
//               <div className="bg-white p-8 text-center">
//                 <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4 font-bold">03</div>
//                 <h4 className="font-bold text-gray-900 mb-2">Month 2+</h4>
//                 <p className="text-sm text-gray-500 uppercase tracking-widest font-semibold mb-3">Long-term Diet</p>
//                 <p className="text-sm text-gray-600">Transitioning to small, nutritious solid meals for life.</p>
//               </div>
//             </div>
//           </section>

//           {/* Video Education Section */}
//           <section className="bg-slate-900 rounded-3xl p-10 text-white">
//             <div className="flex justify-between items-end mb-8">
//               <div>
//                 <h3 className="text-2xl font-bold">Educational Series</h3>
//                 <p className="text-slate-400">Watch Dr. Rishi Singhal explain the procedure details</p>
//               </div>
//               <Button variant="link" className="text-blue-400 p-0">View All Videos</Button>
//             </div>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//               {[1, 2].map((i) => (
//                 <div key={i} className="group relative aspect-video bg-slate-800 rounded-2xl overflow-hidden cursor-pointer border border-slate-700">
//                   <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/40 transition-all">
//                     <PlayCircle className="w-16 h-16 text-white/80 group-hover:text-blue-400 group-hover:scale-110 transition-all" />
//                   </div>
//                   <div className="absolute bottom-4 left-4">
//                     <p className="text-xs font-medium text-blue-400 uppercase tracking-wider mb-1">Episode 0{i}</p>
//                     <p className="font-bold">What to expect during surgery</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </section>

//           {/* Quick Pre-Op Checklist */}
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             <Card className="bg-emerald-50/50 border-emerald-100 shadow-none">
//               <CardHeader>
//                 <CardTitle className="text-emerald-800 flex items-center gap-2">
//                   <CheckCircle2 className="w-5 h-5" /> Pre-Op Checklist
//                 </CardTitle>
//               </CardHeader>
//               <CardContent className="grid gap-3">
//                 {['Full Medical Evaluation', '2-Week Pre-Op Diet', 'Smoking Cessation'].map(task => (
//                   <div key={task} className="flex items-center gap-3 bg-white p-3 rounded-lg border border-emerald-100">
//                     <div className="w-2 h-2 bg-emerald-500 rounded-full" />
//                     <span className="text-sm font-medium text-emerald-900">{task}</span>
//                   </div>
//                 ))}
//               </CardContent>
//             </Card>

//             <Card className="bg-orange-50/50 border-orange-100 shadow-none">
//               <CardHeader>
//                 <CardTitle className="text-orange-800 flex items-center gap-2">
//                   <Info className="w-5 h-5" /> Expert Support
//                 </CardTitle>
//               </CardHeader>
//               <CardContent className="text-orange-900/70 text-sm leading-relaxed">
//                 Our team provides 24/7 post-operative monitoring and a dedicated nutritionist to ensure your weight loss journey is safe and permanent.
//                 <Button variant="link" className="text-orange-700 font-bold p-0 block mt-2">Learn about our Support Group →</Button>
//               </CardContent>
//             </Card>
//           </div>

//         </main>
//       </div>
//     </div>
//   );
// };

// export default GastricBypass;
import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Phone, Mail, Calendar, CheckCircle2, PlayCircle, Activity, Info } from "lucide-react";
import { Link } from "react-router-dom";
import PageBreadcrumb from '../PageBreadcrumb';

const GastricBypass = () => {
  return (
    <div className="min-h-screen bg-[#f8fafc] pb-20">
      
      {/* Breadcrumb */}
      <PageBreadcrumb
        crumbs={[{ label: 'Procedures', to: '/procedures' }]}
        current="Gastric Bypass Surgery"
      />

      {/* Hero Section */}
      <section className="relative bg-[#800000] text-white py-20 px-6 overflow-hidden">
        <div className="absolute top-0 right-0 w-1/3 h-full bg-white/5 skew-x-12 transform translate-x-20" />
        <div className="max-w-6xl mx-auto relative z-10">
          <div className="inline-flex items-center space-x-2 bg-white/20 px-4 py-1.5 rounded-full mb-6 border border-white/30">
            <Activity className="w-4 h-4 text-white" />
            <span className="text-sm font-medium text-white">
              Big Bariatrics
            </span>
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight mb-6">
            Gastric Bypass Surgery
          </h1>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 -mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8">

        {/* Sidebar */}
        <aside className="lg:col-span-3 space-y-6">
          <Card className="sticky top-6 shadow-xl border-none bg-white/90 backdrop-blur-md">
            <CardHeader className="border-b border-gray-100">
              <CardTitle className="text-lg font-bold text-[#800000] flex items-center gap-2">
                <Info className="w-5 h-5 text-[#800000]" /> Patient Portal
              </CardTitle>
            </CardHeader>
            <CardContent className="p-4 space-y-2">
              <div className="mt-4 p-4 bg-[#800000] rounded-2xl text-white shadow-lg">
                <h4 className="font-bold mb-2 flex items-center gap-2">
                  <Calendar className="w-4 h-4" /> For Appointment
                </h4>
                <p className="text-xs text-white/80 mb-4">
                  Book your consultation with our bariatric experts.
                </p>
                <Link to="/contact">
                <Button className="w-full bg-white text-[#800000] hover:bg-gray-100 font-bold mt-2">
                  Reserve Now
                </Button>
                </Link>
                <div className="mt-4 pt-4 border-t border-white/20 space-y-2 text-xs">
                  <div className="flex items-center gap-2">
                    <Phone className="w-3 h-3" /> +91-755-4055123
                  </div>
                  <div className="flex items-center gap-2">
                    <Mail className="w-3 h-3" /> contact@bigbariatrics.com
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </aside>

        {/* Main Content */}
        <main className="lg:col-span-9 space-y-12">

          {/* Procedure Section */}
          <section className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100">
            <div className="flex flex-col md:flex-row gap-12 items-center">
              <div className="flex-1 space-y-6 text-gray-700">
                <p className="text-xl leading-relaxed">
                  Gastric Bypass (Roux-en-Y) is a highly effective bariatric surgery that works by both reducing stomach size and altering the digestive pathway.
                </p>
                <p className="text-lg leading-relaxed">
                  In this procedure, a small pouch is created from the stomach and directly connected to the small intestine, bypassing a portion of the stomach and intestine. This results in reduced food intake and decreased calorie absorption.
                </p>
                <div className="w-full bg-gray-100 rounded-2xl overflow-hidden shadow-inner flex items-center justify-center p-1">
                  <img 
                    src={process.env.PUBLIC_URL + "/bypass.jpg"} 
                    alt="Gastric Bypass Procedure"
                    className="w-full h-full object-fit max-h-96  max-w-96"
                  />
                </div>
                <p className="bg-[#ffe5e5] border-l-4 border-[#800000] p-4 italic rounded-r-lg">
                  Gastric bypass not only restricts food intake but also creates powerful hormonal changes that help control hunger, improve metabolism, and significantly improve conditions like type 2 diabetes.
                </p>

                {/* Benefits */}
                <div>
                  <h4 className="font-bold text-lg text-gray-900 mb-2">
                    Key Benefits
                  </h4>
                  <ul className="list-disc pl-5 space-y-1 text-gray-600">
                    <li>Maximum and rapid weight loss</li>
                    <li>Excellent diabetes remission results</li>
                    <li>Strong hormonal and metabolic effects</li>
                    <li>Long-term weight maintenance</li>
                  </ul>
                </div>

                {/* Who is it for */}
                <div>
                  <h4 className="font-bold text-lg text-gray-900 mb-2">
                    Who is it for?
                  </h4>
                  <ul className="list-disc pl-5 space-y-1 text-gray-600">
                    <li>Patients with severe obesity</li>
                    <li>Individuals with uncontrolled diabetes</li>
                    <li>Patients needing maximum weight loss</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Recovery Section */}
          <section>
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
              Your Recovery Journey
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-0 rounded-3xl overflow-hidden shadow-lg border border-gray-100">
              <div className="bg-white p-8 text-center">
                <div className="w-12 h-12 bg-[#ffe5e5] text-[#800000] rounded-full flex items-center justify-center mx-auto mb-4 font-bold">
                  01
                </div>
                <h4 className="font-bold mb-2">Week 1</h4>
                <p className="text-sm text-gray-600">Liquid diet & healing</p>
              </div>
              <div className="bg-[#ffe5e5] p-8 text-center">
                <div className="w-12 h-12 bg-[#800000] text-white rounded-full flex items-center justify-center mx-auto mb-4 font-bold">
                  02
                </div>
                <h4 className="font-bold mb-2">Weeks 2-4</h4>
                <p className="text-sm text-gray-600">Soft & pureed foods</p>
              </div>
              <div className="bg-white p-8 text-center">
                <div className="w-12 h-12 bg-[#ffe5e5] text-[#800000] rounded-full flex items-center justify-center mx-auto mb-4 font-bold">
                  03
                </div>
                <h4 className="font-bold mb-2">Month 2+</h4>
                <p className="text-sm text-gray-600">Balanced long-term diet</p>
              </div>
            </div>
          </section>

          {/* Video Section */}
          {/* <section className="bg-[#800000] rounded-3xl p-10 text-white">
            <h3 className="text-2xl font-bold mb-6">Educational Videos</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[1, 2].map((i) => (
                <div key={i} className="relative aspect-video bg-[#660000] rounded-xl flex items-center justify-center">
                  <PlayCircle className="w-14 h-14 text-white/70" />
                </div>
              ))}
            </div>
          </section> */}

          {/* Checklist */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Card className="bg-emerald-50 border-emerald-100">
              <CardHeader>
                <CardTitle className="text-emerald-800 flex items-center gap-2">
                  <CheckCircle2 className="w-5 h-5" /> Pre-Op Checklist
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-2">
                <p>Complete health evaluation</p>
                <p>Strict pre-op diet</p>
                <p>Lifestyle preparation</p>
              </CardContent>
            </Card>

            <Card className="bg-orange-50 border-orange-100">
              <CardHeader>
                <CardTitle className="text-orange-800 flex items-center gap-2">
                  <Info className="w-5 h-5" /> Expert Support
                </CardTitle>
              </CardHeader>
              <CardContent>
                Continuous monitoring, nutritional support, and long-term follow-up ensure safe recovery and sustained results.
              </CardContent>
            </Card>
          </div>

        </main>
      </div>
    </div>
  );
};

export default GastricBypass;